import { Box } from '@mui/material';
import React from 'react';
import { environment } from '../../../environments/environment';

const OrangeCircle = () => {
  return (
    <Box
      sx={{
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        backgroundColor: environment.mainColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: 'white',
        }}
      />
    </Box>
  );
};

export default OrangeCircle;
